<template>
    <section>
        <router-view />
        <div
            v-if="$route.name === 'providerSettings'"
            class="affiliatedWrapper"
        >
            <v-card
                class="card"
                raised
                @click="$router.push({name: 'acuGroups'})"
            >
                <v-card-text>
                    <v-card-title class="text--primary d-flex flex-column">
                        <v-avatar size="80" class="teal mr-2 my-4 elevation-5 text-center">
                            <v-icon
                                size="50"
                                class="white--text"
                            >
                                {{ mdiGroup }}
                            </v-icon>
                        </v-avatar>
                        <div class="text-wrap" style="word-break: normal; text-align: center;">
                            Groups
                        </div>
                    </v-card-title>
                </v-card-text>
            </v-card>
            <v-card
                class="card"
                raised
                @click="$router.push({name: 'providerAcuInfo'})"
            >
                <v-card-text>
                    <v-card-title class="text--primary d-flex flex-column">
                        <v-avatar size="80" class="teal mr-2 my-4 elevation-5 text-center">
                            <v-icon
                                size="50"
                                class="white--text"
                            >
                                {{ mdiDoctor }}
                            </v-icon>
                        </v-avatar>
                        <div class="text-wrap" style="word-break: normal; text-align: center;">
                            Provider ACU Info
                        </div>
                    </v-card-title>
                </v-card-text>
            </v-card>
            <v-card
                class="card"
                raised
                @click="$router.push({name: 'acuRates'})"
            >
                <v-card-text>
                    <v-card-title class="text--primary d-flex flex-column">
                        <v-avatar size="80" class="teal mr-2 my-4 elevation-5 text-center">
                            <v-icon
                                size="50"
                                class="white--text"
                            >
                                {{ mdiFileDocumentOutline }}
                            </v-icon>
                        </v-avatar>
                        <div class="text-wrap" style="word-break: normal; text-align: center;">
                            Rates
                        </div>
                    </v-card-title>
                </v-card-text>
            </v-card>
        </div>
    </section>
</template>

<script>
import {
    mdiGroup,
    mdiDoctor,
    mdiFileDocumentOutline
} from '@mdi/js'
export default {
    data: () => ({
        mdiGroup,
        mdiDoctor,
        mdiFileDocumentOutline,
        items: [
            {
                text: 'Dashboard',
                disabled: false,
                href: 'breadcrumbs_dashboard'
            },
            {
                text: 'Link 1',
                disabled: false,
                href: 'breadcrumbs_link_1'
            },
            {
                text: 'Link 2',
                disabled: true,
                href: 'breadcrumbs_link_2'
            }
        ]
    }),
    computed: {
        breadcrumbItems() {
            return this.$route.matched.map(route => ({
                text: route.meta.breadcrumb,  // Get the breadcrumb label from meta
                disabled: route.path === this.$route.path,  // Disable the current route
                to: route.path  // Define the route to navigate
            }))
        }
    },
    methods: {
        navigateTo(item) {
            if (!item.disabled) this.$router.push(item.to)  // Programmatic navigation using router.push
        }
    }
}
</script>

<style scoped>
.affiliatedWrapper {
    height: 90vh;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
}
.card {
    width: 300px;
    height: 200px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background: linear-gradient(180deg, #b4ff9a 0%, #02cf9f 100%);
}
</style>
